// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    offset: "2px !important", // Store Custom Code
    color: "#237e8d", // Store Custom Code
    width: "2px", // Store Custom Code
};

export default focus;
